/* eslint-disable @typescript-eslint/no-explicit-any */
import useErrorStore from "@/store/confirmationStore";

export const showValidationToast = (validationErrors: any, options: any = {}) => {
  const { showError } = useErrorStore.getState();

  if (!validationErrors || Object.keys(validationErrors).length === 0) {
    showError("Please fix the validation errors before previewing. Check the highlighted fields and try again.");
    return;
  }

  const errorMessages = Object.values(validationErrors);
  const formatMessage = (msg: any): string => {
    if (typeof msg === "string") return `• ${msg}`;

    if (typeof msg === "object" && msg !== null) {
      return Object.entries(msg)
        .map(([key, value]) => {
          if (typeof value === "object") {
            return `${key}: ${JSON.stringify(value)}`;
          }
          return `${key}: ${value}`;
        })
        .join(", ");
    }

    return `• ${String(msg)}`;
  };
  const descriptionText = errorMessages.map((msg) => formatMessage(msg)).join("\n");
  const title = options.title || "Validation Errors Found";
  showError(`${title}\n\n${descriptionText}`);
};
